var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Card',[_c('ui-tabs',{attrs:{"tabs":_vm.tabs}},[_c('template',{slot:"content-first"},[_c('div',[_vm._v("First tab")])]),_c('template',{slot:"content-second"},[_c('div',[_vm._v("Second tab")])])],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }